<script>
import {M} from "../../external";
</script>
<div class="automation-row mt-15 automation-end-row">
    <div class="automation-action start-automation">
        <!--<div class="automation-icon flex align-center justify-center automation-start"><span class="material-icons-outlined"> exit_to_app </span></div>-->
        <div class="automation-content">
            <h6 class="mb-0">{M.FLOW_END}</h6>
        </div>
    </div>
</div>
